import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { TrendUp, CheckCircle } from "@phosphor-icons/react";
import CapturesSection from "@/components/CapturesSection";

export default function OverflowCard({ day, closed, onSave, date, warehouse }) {
  const [value, setValue] = useState(day?.estimated_overflow != null ? String(day.estimated_overflow) : "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(day?.estimated_overflow != null ? String(day.estimated_overflow) : "");
  }, [day?.id, day?.estimated_overflow]);

  const save = async () => {
    const n = parseInt(value, 10);
    if (isNaN(n) || n < 0) return;
    setSaving(true);
    try {
      await onSave(n);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-md shadow-sm p-4" data-testid="overflow-card">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            <TrendUp size={14} weight="duotone" /> Estimated Overflow
          </div>
          <p className="text-sm text-slate-500 mt-1">
            Estimated packages still remaining to be processed.
          </p>
        </div>
        {closed ? (
          <div className="font-heading text-3xl font-extrabold text-blue-600" data-testid="overflow-value">
            {day?.estimated_overflow ?? 0}
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <input
              data-testid="overflow-input"
              type="text"
              inputMode="numeric"
              placeholder="0"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="w-32 border border-slate-300 rounded-md px-3 py-2 text-sm text-slate-700 placeholder-slate-400 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none bg-white"
            />
            <Button
              data-testid="overflow-save-btn"
              onClick={save}
              disabled={saving || value === ""}
              className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
            >
              <CheckCircle size={18} weight="bold" className="mr-2" />
              {saving ? "Saving..." : "Save"}
            </Button>
          </div>
        )}
      </div>
      <div className="border-t border-slate-100 mt-4 pt-4">
        <CapturesSection
          date={date}
          warehouse={warehouse}
          closed={closed}
          kind="overflow"
          title="Photos / videos of packages remaining"
          emptyText="No overflow photos or videos yet — upload media of the packages still remaining to be processed."
          embedded
        />
      </div>
    </div>
  );
}
